/* ============================================================
   Brushworks — DIRECTOR'S CUT interaction layer (Shopify port)
   Foil tracking · card tilt · fly-to-cart · footer daisy
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ================= Product manifesto deck ================= */
  function initManifesto(section) {
    if (!section || section.dataset.ready === 'true') return;

    var line = section.querySelector('[data-dc-manifesto-line]');
    var shelf = section.querySelector('[data-dc-manifesto-shelf]');
    var products = Array.prototype.slice.call(section.querySelectorAll('.dc-manifesto-product'));
    if (!line || !shelf || !products.length) return;

    section.dataset.ready = 'true';

    var highlights = (line.dataset.highlights || '')
      .split(',')
      .map(function (word) { return word.trim(); })
      .filter(Boolean);
    var words = line.textContent.split(/\s+/).filter(Boolean);
    line.textContent = '';
    words.forEach(function (word, index) {
      if (index) line.append(document.createTextNode(' '));
      var span = document.createElement('span');
      span.className = 'dc-w';
      if (highlights.some(function (highlight) {
        return word.replace(/[.,!?]/g, '') === highlight.replace(/[.,!?]/g, '');
      })) {
        span.classList.add('dc-hl');
      }
      span.textContent = word;
      line.append(span);
    });

    var spans = Array.prototype.slice.call(line.querySelectorAll('.dc-w'));
    var lastLit = -1;
    var queued = false;
    var productsReady = false;
    var productsRevealed = false;

    products.forEach(function (product) {
      product.setAttribute('inert', '');
    });

    function layoutDeck() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var shelfWidth = shelf.getBoundingClientRect().width;
      var cardWidth = parseFloat(window.getComputedStyle(products[0]).width) || (mobile ? 110 : 150);
      var available = Math.max(1, shelfWidth - cardWidth - (mobile ? 28 : 36));
      var spread = products.length > 1
        ? Math.min(mobile ? 34 : 96, Math.max(mobile ? 25 : 56, available / (products.length - 1)))
        : 0;
      var centre = (products.length - 1) / 2;

      products.forEach(function (product, index) {
        var slot = index - centre;
        product.style.setProperty('--dc-card-x', (slot * spread).toFixed(1) + 'px');
        product.style.setProperty('--dc-card-y', (Math.abs(slot) * (mobile ? 2.5 : 4.25)).toFixed(1) + 'px');
        product.style.setProperty('--dc-card-rotate', (slot * (mobile ? 3.2 : 2.45)).toFixed(2) + 'deg');
        product.style.setProperty('--dc-card-z', index + 1);
      });
    }

    function revealProductsOnce() {
      if (!productsReady || productsRevealed) return;
      var bounds = section.getBoundingClientRect();
      if (bounds.bottom <= 0 || bounds.top >= window.innerHeight * 0.88) return;

      productsRevealed = true;
      section.dataset.productsRevealed = 'true';
      shelf.classList.add('is-visible');
      products.forEach(function (product, index) {
        window.setTimeout(function () {
          product.classList.add('is-visible');
          product.removeAttribute('inert');
        }, index * 110);
      });
    }

    function watchProductImages() {
      var images = Array.prototype.slice.call(section.querySelectorAll('.dc-manifesto-product__media'));
      if (!images.length) {
        productsReady = true;
        schedule();
        return;
      }

      var remaining = images.length;
      function markLoaded() {
        remaining -= 1;
        if (remaining > 0) return;
        productsReady = true;
        section.dataset.productsReady = 'true';
        schedule();
      }

      images.forEach(function (image) {
        if (image.complete) {
          markLoaded();
          return;
        }
        image.addEventListener('load', markLoaded, { once: true });
        image.addEventListener('error', markLoaded, { once: true });
      });
    }

    function hydrateProductImages() {
      Array.prototype.forEach.call(section.querySelectorAll('[data-dc-deferred-src]'), function (image) {
        image.src = image.dataset.dcDeferredSrc;
        image.removeAttribute('data-dc-deferred-src');
      });
      watchProductImages();
    }

    if ('IntersectionObserver' in window) {
      var productImageObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        productImageObserver.disconnect();
        hydrateProductImages();
      }, { rootMargin: '600px 0px' });
      productImageObserver.observe(section);
    } else {
      hydrateProductImages();
    }

    function render() {
      queued = false;
      var bounds = section.getBoundingClientRect();
      var revealDistance = Math.max(1, window.innerHeight * 0.82);
      var progress = Math.min(1, Math.max(0, (window.innerHeight - bounds.top) / revealDistance));
      var wordProgress = Math.min(1, progress / 0.58);
      var lit = Math.round(wordProgress * spans.length);

      if (lit !== lastLit) {
        lastLit = lit;
        spans.forEach(function (span, index) {
          span.classList.toggle('lit', index < lit);
        });
      }
      revealProductsOnce();
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(render);
    }

    layoutDeck();
    if (reduce) {
      spans.forEach(function (span) { span.classList.add('lit'); });
      shelf.classList.add('is-visible');
      products.forEach(function (product) {
        product.classList.add('is-visible');
        product.removeAttribute('inert');
      });
      return;
    }

    render();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(render);
    });
    new IntersectionObserver(schedule, { rootMargin: '20% 0px' }).observe(section);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    window.addEventListener('pageshow', schedule);
    window.addEventListener('resize', function () {
      layoutDeck();
      schedule();
    }, { passive: true });
  }

  var manifestoObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          manifestoObserver.unobserve(entry.target);
          initManifesto(entry.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;

  function queueManifesto(section) {
    if (!section || section.dataset.dcManifestoQueued === 'true') return;
    section.dataset.dcManifestoQueued = 'true';
    if (manifestoObserver) manifestoObserver.observe(section);
    else initManifesto(section);
  }

  function initManifestos(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-dc-manifesto]')) queueManifesto(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-dc-manifesto]'), queueManifesto);
    }
  }

  initManifestos(document);
  document.addEventListener('shopify:section:load', function (event) {
    initManifestos(event.target);
  });
  if (window.Shopify && window.Shopify.designMode) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) initManifestos(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ================= Editorial hero slideshow ================= */
  function initHeroSlider(root) {
    if (!root || root.dataset.dcSliderReady === 'true') return;
    root.dataset.dcSliderReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dc-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dc-hero-dot]'));
    var previous = root.querySelector('[data-dc-hero-prev]');
    var next = root.querySelector('[data-dc-hero-next]');
    var pause = root.querySelector('[data-dc-hero-pause]');
    var pauseIcon = root.querySelector('[data-dc-hero-pause-icon]');
    var interval = Math.max(4000, Number(root.dataset.interval) || 7000);
    var canAutoplay = root.dataset.autoplay === 'true' && !reduce && slides.length > 1;
    var current = 0;
    var timer = null;
    var preloadTimer = null;
    var manuallyPaused = false;
    var slideRequest = 0;

    function loadSlide(slide) {
      if (!slide) return Promise.resolve();
      var image = slide.querySelector('img[data-src]');
      if (!image) return Promise.resolve();
      Array.prototype.forEach.call(slide.querySelectorAll('source[data-srcset]'), function (source) {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      slide.dataset.mediaLoaded = 'true';
      if (typeof image.decode === 'function') {
        return image.decode().catch(function () {});
      }
      return new Promise(function (resolve) {
        if (image.complete) resolve();
        else {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        }
      });
    }

    function activateSlide(index) {
      current = index;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        if (!active && slide.classList.contains('dc-hero-slide--initial')) {
          slide.classList.remove('dc-hero-slide--initial');
        }
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
      });
    }

    function setSlide(index) {
      var target = (index + slides.length) % slides.length;
      var request = ++slideRequest;
      return loadSlide(slides[target]).then(function () {
        if (request === slideRequest) activateSlide(target);
      });
    }

    function stop() {
      if (timer) window.clearTimeout(timer);
      if (preloadTimer) window.clearTimeout(preloadTimer);
      timer = null;
      preloadTimer = null;
    }

    function start() {
      stop();
      if (!canAutoplay || manuallyPaused) return;
      preloadTimer = window.setTimeout(function () {
        loadSlide(slides[(current + 1) % slides.length]);
      }, Math.max(0, interval - 1800));
      timer = window.setTimeout(function () {
        setSlide(current + 1).then(start);
      }, interval);
    }

    function togglePause() {
      manuallyPaused = !manuallyPaused;
      if (pauseIcon) pauseIcon.textContent = manuallyPaused ? '▶' : 'II';
      pause.setAttribute('aria-label', manuallyPaused ? 'Play slideshow' : 'Pause slideshow');
      if (manuallyPaused) stop();
      else start();
    }

    if (previous) previous.addEventListener('click', function () { stop(); setSlide(current - 1).then(start); });
    if (next) next.addEventListener('click', function () { stop(); setSlide(current + 1).then(start); });
    if (pause) pause.addEventListener('click', togglePause);
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { stop(); setSlide(dotIndex).then(start); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) start();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var selectedSlide = event.target.closest('[data-dc-hero-slide]');
      if (!selectedSlide || !root.contains(selectedSlide)) return;
      var selectedIndex = slides.indexOf(selectedSlide);
      if (selectedIndex < 0) return;
      manuallyPaused = true;
      setSlide(selectedIndex);
      stop();
      if (pause) {
        if (pauseIcon) pauseIcon.textContent = '▶';
        pause.setAttribute('aria-label', 'Play slideshow');
      }
    });

    activateSlide(0);
    start();
  }

  function hydrateHeroSlider(root) {
    if (!root || root.dataset.dcHeroHydrated === 'true') return;
    var template = root.querySelector('template[data-dc-hero-deferred-template]');
    var stage = root.querySelector('.dc-hero-stage');
    if (template && stage) {
      stage.appendChild(template.content.cloneNode(true));
      template.remove();
    }
    root.dataset.dcHeroHydrated = 'true';
    initHeroSlider(root);
  }

  function hydrateInitialHeroSliders() {
    document.querySelectorAll('[data-dc-hero-slider]').forEach(hydrateHeroSlider);
  }

  if (window.Shopify && window.Shopify.designMode) {
    hydrateInitialHeroSliders();
  } else if (document.readyState === 'complete') {
    hydrateInitialHeroSliders();
  } else {
    window.addEventListener('load', hydrateInitialHeroSliders, { once: true });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.matches && event.target.matches('[data-dc-hero-slider]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-dc-hero-slider]');
    if (slider) hydrateHeroSlider(slider);
  });

  /* ================= Foil light tracking ================= */
  if (fine && !reduce && document.body.classList.contains('bw-packaging-foil-motion')) {
    var foilSelector = [
      '.dc-hero',
      '.bw-pdp-buy-card',
      '.bw-pdp-details__card',
      '.bw-pdp-main-image',
      '.bw-product-card',
      '.bw-category-card',
      '.bw-routine-feature',
      '.dc-routine-visual',
      '.bw-tiktok-card',
      '.bw-you-gallery figure',
      '.bw-journal-card',
      '.bw-home-split > .text-panel',
      '.bw-home-split > .media',
      '.bw-panel',
      '.bw-image-panel',
      '.newsletter-band',
      '.bw-newsletter-band',
      '.bw-help-panel',
      '.tt-feature',
      '.bw-article-shop'
    ].join(',');
    var foilElement = null;
    var foilFrame = null;
    var foilX = 0;
    var foilY = 0;

    function renderFoil() {
      foilFrame = null;
      if (!foilElement) return;
      var r = foilElement.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = Math.max(0, Math.min(100, ((foilX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((foilY - r.top) / r.height) * 100));
      foilElement.style.setProperty('--bw-foil-pointer-x', x.toFixed(1) + '%');
      foilElement.style.setProperty('--bw-foil-pointer-y', y.toFixed(1) + '%');
    }

    document.addEventListener('pointermove', function (e) {
      var next = e.target.closest(foilSelector);
      if (!next) return;
      foilElement = next;
      foilX = e.clientX;
      foilY = e.clientY;
      if (!foilFrame) foilFrame = requestAnimationFrame(renderFoil);
    }, { passive: true });

    document.addEventListener('pointerout', function (e) {
      var current = e.target.closest(foilSelector);
      if (!current || current.contains(e.relatedTarget)) return;
      current.style.removeProperty('--bw-foil-pointer-x');
      current.style.removeProperty('--bw-foil-pointer-y');
      if (foilElement === current) foilElement = null;
    }, { passive: true });
  }

  /* ================= Product-card tilt ================= */
  if (fine && !reduce) {
    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest('.bw-product-card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      card.classList.add('dc-tilting');
      card.style.transform = 'perspective(900px) translateY(-6px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 4).toFixed(2) + 'deg)';
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest('.bw-product-card');
      if (!card || card.contains(e.relatedTarget)) return;
      card.classList.remove('dc-tilting');
      card.style.transform = '';
    }, { passive: true });
  }

  /* ================= Fly-to-cart =================
     Dawn's product-form handles the AJAX add; we only add the flourish. */
  function flyToCart(fromEl) {
    if (reduce || !fromEl) return;
    var target = document.querySelector('#cart-icon-bubble');
    if (!target) return;
    var img = fromEl.querySelector('img');
    var f = fromEl.getBoundingClientRect();
    var t = target.getBoundingClientRect();
    var fly = document.createElement('div');
    fly.className = 'dc-fly';
    if (img && img.currentSrc) fly.style.backgroundImage = 'url("' + img.currentSrc + '")';
    var startX = f.left + f.width / 2 - 36;
    var startY = f.top + f.height / 2 - 36;
    fly.style.left = startX + 'px';
    fly.style.top = startY + 'px';
    document.body.appendChild(fly);
    void fly.offsetWidth;
    var dx = (t.left + t.width / 2 - 36) - startX;
    var dy = (t.top + t.height / 2 - 36) - startY;
    fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.18) rotate(12deg)';
    fly.style.opacity = '0.25';
    setTimeout(function () { fly.remove(); }, 720);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    var card = form.closest('.bw-product-card');
    var source = card
      ? card.querySelector('.bw-product-card__visual')
      : document.querySelector('.bw-pdp-main-image');
    flyToCart(source);
  }, true);

})();
